// components/industry-templates/MediaEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Tv, Radio, Newspaper, Video } from 'lucide-react';

export const MediaEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Media Platforms */}
      {industryData?.media_platforms && (
        <Card className="border-0 bg-gradient-to-br from-red-500/20 to-pink-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Tv className="w-8 h-8" style={{ color: theme.primary }} />
              Media & Broadcasting
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.media_platforms.map((platform: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                  <h3 className="text-xl font-bold text-white mb-2">{platform.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{platform.type}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{platform.reach}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Content Creation */}
      {industryData?.content_sessions && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Video className="w-6 h-6" style={{ color: theme.primary }} />
              Content Creation Workshops
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.content_sessions.map((session: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white">{session.topic}</h4>
                  <p className="text-sm text-slate-400">{session.creator}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
